import apiClient from "api-client";

import getWrappedUseMutation from "../../helpers/getWrappedUseMutation";

export const useBookAttendeeToMeetingMutation = getWrappedUseMutation(apiClient.AttendeeOnSiteMeetings.post);
